
import { $,_,Backbone,Marionette,Foundation } from '../../../vendor';
import { Notification,Biscuit } from '../../utils';
import InboomaBaseView from '../InboomaBaseView';
import InboomaBaseCollectionView from '../InboomaBaseCollectionView';
import OffCanvasEmailForm from '../users/OffCanvasEmailForm';
import User from '../../models/User'

import UsersItemStaffTpl from '../../templates/users/UsersItemStaffTpl.html';

const UsersItemStaffView = InboomaBaseView.extend({

    template : UsersItemStaffTpl,
    className () { 

      // @todo optimize in terms of performance
      return 'inb-c-item inb-c-item--user medium-4 small-12 column' 
              + (Biscuit.get('user.id') == this.model.get('id') ? ' is-own-user' : '')
              
    },
  
    ui : {
      dropdown : '.inb-dropdown',
      toggleBtn : '.inb-toggle-order-dd',
      selectRole : '.inb-role-select',
      removeUser : '.inb-user-remove',
      'openEmailSettings' : '#user-email-settings',
    },
  
    events : {
      'change @ui.selectRole' : '_roleChanged',
      'click @ui.removeUser' : '_removeUser',
      'click @ui.openEmailSettings' : '_openEmailSettings',
    },
  
    templateContext () {
      return {
        _,
        Biscuit,
        'roles' : ['admin','user','manager','booking-manager','manager-location', 'garage-staff'/*, 'guide'*/, 'mediator']
      }
    },
  
    _removeUser () {
  
      const that = this;

        let rights = {
            'user': 0, 'manager': 1, 'booking-manager': 1,'manager-location': 1, 'admin': 2
        }

        var role = Biscuit.get('user.role');
        var targetRole = this.model.get('role');
        if(rights[role] > rights[targetRole]) {
            if (confirm(this.t('really_remove'))) {
                this.model.destroy({
                    success (model, repsonse) {

                        that.$el.fadeOut('fast');
                        new Notification({
                            message: that.t('removed_${a}', {a: that.t('user')}, 'capital'),
                            duration: 5000,
                            closeable: true,
                            icon: 'fi fi-trash'
                        });

                    }
                });
            }

        } else {
            new Notification({
                message: that.t('cannot_remove_${a}', {a: that.t('user')}, 'capital'),
                duration: 5000,
                closeable: true,
                icon: 'fi fi-trash'
            });
        }
  
    },
  
    _roleChanged (target) {
  
      const t = $(target.currentTarget),
            that = this;

      let rights = {
          'user': 0, 'manager': 1, 'booking-manager' : 1,'manager-location': 1, 'admin': 2
      }

      var role = Biscuit.get('user.role');
      var targetRole = this.model.get('role');

      if (t.val() != '') {
          if (rights[role] > rights[targetRole] && rights[t.val()] <= rights[role]) {
              // If is own user: reset role-cookie,
              // reload page

              this.model.set('role', t.val()).save(null, {
                      type: 'PATCH',
                      success (_model, response) {

                          new Notification({
                              message: that.t('updated_${a}', {a: that.t('user')}),
                              duration: 5000,
                              type: 'success',
                              closeable: true,
                              icon: 'fi fi-check'
                          });

                          that.render();
                     }
              });
          } else {
              new Notification({
                  message: that.t('cannot_update_${a}_${b}', {a: that.t('user')+that.t('with_role_${r}', {r: that.t('role_'+targetRole)}), b: that.t('role_'+t.val())}),
                  duration: 5000,
                  type: 'success',
                  closeable: true,
                  icon: 'fi fi-check'
              });

              that.render();
          }
  
      }
  
    },

    _openEmailSettings (e) {

      e.preventDefault();
      const that = this,
            //user = new User({ id : Biscuit.get('user.id') });
            user = new User({ id : this.model.get('id') });

      user.fetch({
        success (model, response) {
        
          //that._dropdown.close();
          model = new User(response.data);
            let actPath= document.location.pathname;
            document.location="/usersExtension/mailSettings?id=" + model.get('id') + "&path=" + actPath;
        
        },
        error () {
          alert('Could not load the logged in user. Please try again later.');
        }
      });
      return false;
    },
  
    onRender () {
      // In case of any future performance issues: Remove
      // calls on Foundation whilst rendering, as in 
      // OrdersView._initDropdown();
  
      const that = this;
        
      Foundation.Motion.animateIn(this.$el, 'fade-in', () => {
        new Foundation.Dropdown(that.getUI('dropdown'));
      });
    }
  });

  export default InboomaBaseCollectionView.extend({

    childView: UsersItemStaffView,
    template: _.noop,
  
    initialize () {
      //this.collection.filterByRole(['admin','manager','manager-location']);
      InboomaBaseCollectionView.prototype.initialize.apply(this);
      this.$el.html('');
      this.render();
      this.listenTo(this.collection, "add", this.onChangeChildView,this);
      this.listenTo(this.collection, "remove", this.onChangeChildView,this);
      //$('#staff-badge').html(this.collection.models.length);

    },

    onChangeChildView (model,collection,options) {

      const that = this;

      setTimeout( function () {                                                                             // timer is necessary to ensure that pagination has the correct value
        if (that.collection.length < that.collection._pagination.count) {
          var nextBtn = document.getElementsByClassName('inb-next-page-button')[0];
          if (typeof nextBtn !== 'undefined') nextBtn.className = 'inb-next-page-button button';
        }
        else {
          var nextBtn = document.getElementsByClassName('inb-next-page-button')[0];
          if (typeof nextBtn !== 'undefined') nextBtn.className = 'inb-next-page-button button hide';
        }
      },200);
    },
  
    onRender () {
  
      if (!this.hasNextPageListener) {

        const that = this;
        var nextBtn = document.getElementsByClassName('inb-next-page-button')[0];

        nextBtn.addEventListener("click",function () {
          if (document.location.href.indexOf('users/staff') < 0) return;
          that.collection.fetchNextPage();
        });
        this.hasNextPageListener = true;
      }
    }
  
  });  